<template>
  <table v-if="premiums && premiums.length > 0" class="info-table table table-sm mb-0">
    <tr>
      <th class="border-top-0">
        {{ $t('Percentage') }}
      </th>
      <th class="border-top-0" v-if="premiums.length > 1">
        {{ $t('Over') }}
      </th>
    </tr>
    <tr v-for="(premium, index) in premiums" :key="`premium-visual-tier-${index}`">
      <td :colspan="premiums.length > 1 ? 1 : 2">{{ premium.percent }} %</td>
      <td v-if="premiums.length > 1">{{ premium.amount_over | asCurrency(currency ? currency.symbol : null) }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Minimum premium') }}</td>
      <td>{{ minimum_premium | asCurrency }}</td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "PremiumsDisplayTable",
    props: {
      premiums: {
        type: Array,
        default: () => []
      },
      minimum_premium: {
        default: 0
      },
      currency: {
        type: Object,
        default: null
      },
    }
  }
</script>

<style scoped>

</style>